// extracted by mini-css-extract-plugin
export var list = "tiles-module--list--1MYzD";
export var jsAnimInit = "tiles-module--jsAnimInit--1DqrL";